module.exports = __webpack_public_path__ + "img/content4-4.f6b9506a.png";